import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { uploadUrl } from './uploadUrl';
const Testimonial = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [categories,setCategories]=useState([]);

const [handleedit,seteditData]=useState({
    id:null,
   companyname: '',
    text: '',
    location: '',
    media:'',
    big_image:''
   
  })

  const [showeditmodal,setshoweditmodal]=useState(false); 

const [formData, setFormData] = useState({
    companyname: '',
    text: '',
    location: '',
    media:'',
    big_image:''
  
  });
  

  const fetchcategories=async()=>{
    try{
     const res=await axios.get('https://api.squareandangle.pranatigroup.in/api/admin/testimonial');
     console.log(res.data);
     setCategories(res.data);
    }catch(e){
      setError(e.response?.data?.message || 'Save failed');
    }
  }
  
  useEffect(() => {
   fetchcategories();
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const handleOpenModal = () => {
    setFormData({ companyname: '', text: '', media: '' });
    setShowModal(true);
    setError('');
  };
const handlesave = async () => {
    setLoading(true);
    setError('');
    try {
      const data=new FormData();
      data.append('companyname',formData.companyname);
      data.append('location',formData.location);
      data.append('text',formData.text);
      if (formData.media) {
        data.append('media',formData.media);
      }
      if (formData.big_image) {
        data.append('big_image',formData.big_image);
      }
     
      await axios.post('https://api.squareandangle.pranatigroup.in/api/admin/testimonial',data,{
      headers:{
        "Content-Type":'multipart/form-data'
      }
      });
      setShowModal(false);
      setFormData({ companyname: '', text: '', location: '', media: '', big_image: ''});
      fetchcategories();
    } catch (e) {
      setError(e.response?.data?.message || 'Save failed');
    } finally {
      setLoading(false);
    }
  };


const handleeditin=(item)=>{
    seteditData({
      id:item.id,
      companyname:item.name,
      location:item.location || '',
      text:item.Review,
      media:item.image || '',
      big_image:item.big_image || ''
    })
    setshoweditmodal(true);
   }
 
   const handledelete=async(id)=>{
     setLoading(true);
    try{
         await axios.delete(`https://api.squareandangle.pranatigroup.in/api/admin/testimonial/${id}`);
      fetchcategories();
    }catch(e){
        setError(e.response?.data?.message || 'Save failed');
    }finally{
      setLoading(false);
    }
   }


const handleupdatecat=async()=>{
     setLoading(true);
     setError('');
    try{

       const data=new FormData();
      data.append('companyname',handleedit.companyname);
      data.append('location',handleedit.location);
      data.append('text',handleedit.text);
      if (handleedit.media) {
        data.append('media',handleedit.media);
      }
      if (handleedit.big_image) {
        data.append('big_image',handleedit.big_image);
      }
     
      await axios.put(`https://api.squareandangle.pranatigroup.in/api/admin/testimonial/${handleedit.id}`,data,{
        headers:{"Content-Type":"multipart/form-data"}
      }
      
      );
      fetchcategories();
      setshoweditmodal(false);
      setLoading(false);
    }catch(e){
      setError(e.response?.data?.message || 'Update failed');
      setLoading(false);
      setshoweditmodal(false);
    }
   }

  const stylesD = {
    width: "169%",
    paddingRight: "1102px",
    paddingLeft: "15px",
    marginRight: "auto",
    marginLeft: "auto"
  };
  return (
    <>
      {error && <div className="alert alert-danger">{error}</div>}
      <div className="container-fluid" style={isMobile ? {} : stylesD}>
        <div className="d-flex justify-content-between align-items-center mb-3 px-2 w-100">
          <h3 className="m-0">Testimonial</h3>
          <button className="btn btn-primary" onClick={handleOpenModal}>+ Add New</button>
        </div>
        <div className="table-responsive w-100 p-0">
          <table className="table table-bordered table-striped bg-white w-100 m-0">
            <thead className="thead-dark">
              <tr>
                <th>Serial No</th>
                <th>Name</th>
                <th>Location</th>
                <th>Text</th>
                <th>Image</th>
                 <th>Broad Image</th>
                <th className="text-center">Actions</th>
              </tr>
            </thead>
            <tbody>
            
                {
                categories.length>0 ?(
                
                categories.map((item, index) => (
                <tr key={item.id}>
               
                  <td>{index +1}</td>
                  <td>{item.name}</td>
                    <td>{item.location}</td>
                  <td>{item.Review}</td>
                   <td><img src={uploadUrl(item.image)} alt="pranati website" width="100"/></td>
                 <td><img src={uploadUrl(item.big_image)} alt="pranati website" width="100"/></td>
                  <td className="text-center">
                    <button className="btn btn-sm btn-outline-primary mr-2" onClick={()=>handleeditin(item)}>Edit</button>
                    <button className="btn btn-sm btn-outline-danger" onClick={()=>handledelete(item.id)}>Delete</button>
                  </td>
                </tr>
              ))
                ):(
               <tr>

                <td colSpan="5" className="text-center text-muted">
                  No Company Data Found
                </td>
               </tr>

                )}
            </tbody>

            
           
          </table>
        </div>
      </div>
      {showModal && (
        <div className="modal show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Add Testimonial</h5>
                <button 
                  className="close" 
                  style={{ background: 'transparent', border: 'none', fontSize: '1.5rem' }} 
                  onClick={() => setShowModal(false)}
                >
                  ×
                </button>
              </div>
              <div className="modal-body">
                <input 
                  type="text"
                  className="form-control mb-2"
                  placeholder="Name"
                  value={formData.companyname} 
                  onChange={(e) => setFormData({ ...formData, companyname: e.target.value })}
                />
                 <input 
                  type="text"
                  className="form-control mb-2"
                  placeholder="Location"
                  value={formData.location} 
                  onChange={(e) => setFormData({ ...formData, location: e.target.value })}
                />

                 <textarea 
                  type="text"
                  className="form-control mb-2"
                  placeholder="text"
                  value={formData.text} 
                  onChange={(e) => setFormData({ ...formData, text: e.target.value })}
                />
                <input 
                  type="file"
                  className="form-control mb-2"
                  placeholder="Filename"
                  onChange={(e) => setFormData({ ...formData, media: e.target.files[0] })}
                />
                 <input 
                  type="file"
                  className="form-control mb-2"
                  placeholder="Filename"
                  onChange={(e) => setFormData({ ...formData, big_image: e.target.files[0] })}
                />
                
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={() => setShowModal(false)}>
                  Close
                </button>
                <button className="btn btn-primary" onClick={handlesave} disabled={loading}>
                  {loading ? 'Saving...' : 'Save'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}



      {showeditmodal && (
        <div className="modal show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Edit Testimonial</h5>
                <button 
                  className="close" 
                  style={{ background: 'transparent', border: 'none', fontSize: '1.5rem' }} 
                  onClick={() => setshoweditmodal(false)}
                >
                  ×
                </button>
              </div>
              <div className="modal-body">
                <input 
                  type="text"
                  className="form-control mb-2"
                  placeholder="Company Name"
                  value={handleedit.companyname} 
                  onChange={(e) => seteditData({ ...handleedit, companyname: e.target.value })}
                />
                <input 
                  type="text"
                  className="form-control mb-2"
                  placeholder="Company Name"
                  value={handleedit.location} 
                  onChange={(e) => seteditData({ ...handleedit, location: e.target.value })}
                />
                 <textarea 
                  type="text"
                  className="form-control mb-2"
                  placeholder="text"
                  value={handleedit.text} 
                  onChange={(e) => seteditData({ ...handleedit, text: e.target.value })}
                />
                <input 
                  type="file"
                  className="form-control mb-2"
                  placeholder="Filename"
                  onChange={(e) => seteditData({ ...handleedit, media: e.target.files[0] })}
                />
              <input 
                  type="file"
                  className="form-control mb-2"
                  placeholder="Filename"
                  onChange={(e) => seteditData({ ...handleedit, big_image: e.target.files[0] })}
                />
              
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={() => setshoweditmodal(false)}>
                  Close
                </button>
                <button className="btn btn-primary" onClick={handleupdatecat} disabled={loading}>
                  {loading ? 'Saving...' : 'Save'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
export default Testimonial;